// extracted by mini-css-extract-plugin
module.exports = {"price":"BundlePrice_price__22Yd2","symbol":"BundlePrice_symbol__A618o"};